var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOzbek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_1186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13H24V19H0V13Z",
    fill: "#1EB53A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1H24V7H0V1Z",
    fill: "#0099B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.76001H24V13.24H0V6.76001Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.12H24V12.88H0V7.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03988 6.03997C6.23282 6.03997 7.19988 5.07291 7.19988 3.87997C7.19988 2.68704 6.23282 1.71997 5.03988 1.71997C3.84695 1.71997 2.87988 2.68704 2.87988 3.87997C2.87988 5.07291 3.84695 6.03997 5.03988 6.03997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75961 6.03997C6.95254 6.03997 7.91961 5.07291 7.91961 3.87997C7.91961 2.68704 6.95254 1.71997 5.75961 1.71997C4.56667 1.71997 3.59961 2.68704 3.59961 3.87997C3.59961 5.07291 4.56667 6.03997 5.75961 6.03997Z",
    fill: "#0099B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7911 5.17676L9.6543 5.58716L9.8631 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79093 5.17676L9.92773 5.58716L9.71893 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2024 5.47532L9.76984 5.47204L9.76589 5.69287",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2028 5.47536L9.8548 5.73229L9.7218 5.55596",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38016 5.47524L9.7282 5.73217L9.8612 5.55584",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38058 5.4752L9.81317 5.47191L9.81712 5.69274",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0446 5.95822L9.91405 5.54579L9.7028 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0443 5.95817L9.69237 5.70655L9.81897 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53679 5.95817L9.88869 5.70655L9.76209 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53645 5.95822L9.66701 5.54579L9.87825 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7911 3.44873L9.6543 3.85913L9.8631 3.93113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79093 3.44873L9.92773 3.85913L9.71893 3.93113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2024 3.74729L9.76984 3.74401L9.76589 3.96484",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2028 3.74734L9.8548 4.00426L9.7218 3.82793",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38016 3.74721L9.7282 4.00414L9.8612 3.82781",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38058 3.74717L9.81317 3.74389L9.81712 3.96472",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0446 4.23019L9.91405 3.81776L9.7028 3.88224",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0443 4.23014L9.69237 3.97853L9.81897 3.79755",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53679 4.23014L9.88869 3.97853L9.76209 3.79755",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53645 4.23019L9.66701 3.81776L9.87825 3.88224",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7911 1.7207L9.6543 2.1311L9.8631 2.2031",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79093 1.7207L9.92773 2.1311L9.71893 2.2031",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2024 2.01926L9.76984 2.01598L9.76589 2.23681",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2028 2.01931L9.8548 2.27623L9.7218 2.0999",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38016 2.01919L9.7282 2.27611L9.8612 2.09978",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38058 2.01914L9.81317 2.01586L9.81712 2.23669",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0446 2.50216L9.91405 2.08973L9.7028 2.15421",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0443 2.50211L9.69237 2.2505L9.81897 2.06952",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53679 2.50211L9.88869 2.2505L9.76209 2.06952",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53645 2.50216L9.66701 2.08973L9.87825 2.15421",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5186 5.17676L11.3818 5.58716L11.5906 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5185 5.17676L11.6553 5.58716L11.4465 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.93 5.47532L11.4974 5.47204L11.4934 5.69287",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9304 5.47536L11.5823 5.73229L11.4493 5.55596",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1077 5.47524L11.4557 5.73217L11.5887 5.55584",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1081 5.4752L11.5407 5.47191L11.5447 5.69274",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7721 5.95822L11.6416 5.54579L11.4303 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7718 5.95817L11.4199 5.70655L11.5465 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2643 5.95817L11.6162 5.70655L11.4896 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.264 5.95822L11.3945 5.54579L11.6058 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5186 3.44873L11.3818 3.85913L11.5906 3.93113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5185 3.44873L11.6553 3.85913L11.4465 3.93113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.93 3.74729L11.4974 3.74401L11.4934 3.96484",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9304 3.74734L11.5823 4.00426L11.4493 3.82793",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1077 3.74721L11.4557 4.00414L11.5887 3.82781",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1081 3.74717L11.5407 3.74389L11.5447 3.96472",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7721 4.23019L11.6416 3.81776L11.4303 3.88224",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7718 4.23014L11.4199 3.97853L11.5465 3.79755",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2643 4.23014L11.6162 3.97853L11.4896 3.79755",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.264 4.23019L11.3945 3.81776L11.6058 3.88224",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5186 1.7207L11.3818 2.1311L11.5906 2.2031",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5185 1.7207L11.6553 2.1311L11.4465 2.2031",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.93 2.01926L11.4974 2.01598L11.4934 2.23681",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9304 2.01931L11.5823 2.27623L11.4493 2.0999",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1077 2.01919L11.4557 2.27611L11.5887 2.09978",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1081 2.01914L11.5407 2.01586L11.5447 2.23669",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7721 2.50216L11.6416 2.08973L11.4303 2.15421",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7718 2.50211L11.4199 2.2505L11.5465 2.06952",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2643 2.50211L11.6162 2.2505L11.4896 2.06952",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.264 2.50216L11.3945 2.08973L11.6058 2.15421",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2472 5.17676L13.1104 5.58716L13.3192 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.247 5.17676L13.3838 5.58716L13.175 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6585 5.47532L13.2259 5.47204L13.2219 5.69287",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6589 5.47536L13.3109 5.73229L13.1779 5.55596",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8362 5.47524L13.1843 5.73217L13.3173 5.55584",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8366 5.4752L13.2692 5.47191L13.2732 5.69274",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5007 5.95822L13.3701 5.54579L13.1589 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 5.95817L13.1484 5.70655L13.275 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9928 5.95817L13.3447 5.70655L13.2181 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9925 5.95822L13.1231 5.54579L13.3343 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2472 3.44873L13.1104 3.85913L13.3192 3.93113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.247 3.44873L13.3838 3.85913L13.175 3.93113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6585 3.74729L13.2259 3.74401L13.2219 3.96484",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6589 3.74734L13.3109 4.00426L13.1779 3.82793",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8362 3.74721L13.1843 4.00414L13.3173 3.82781",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8366 3.74717L13.2692 3.74389L13.2732 3.96472",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5007 4.23019L13.3701 3.81776L13.1589 3.88224",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 4.23014L13.1484 3.97853L13.275 3.79755",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9928 4.23014L13.3447 3.97853L13.2181 3.79755",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9925 4.23019L13.1231 3.81776L13.3343 3.88224",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2472 1.7207L13.1104 2.1311L13.3192 2.2031",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.247 1.7207L13.3838 2.1311L13.175 2.2031",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6585 2.01926L13.2259 2.01598L13.2219 2.23681",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6589 2.01931L13.3109 2.27623L13.1779 2.0999",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8362 2.01919L13.1843 2.27611L13.3173 2.09978",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8366 2.01914L13.2692 2.01586L13.2732 2.23669",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5007 2.50216L13.3701 2.08973L13.1589 2.15421",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 2.50211L13.1484 2.2505L13.275 2.06952",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9928 2.50211L13.3447 2.2505L13.2181 2.06952",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9925 2.50216L13.1231 2.08973L13.3343 2.15421",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33504 5.17676L6.19824 5.58716L6.40704 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33488 5.17676L6.47168 5.58716L6.26288 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74638 5.47532L6.31379 5.47204L6.30983 5.69287",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74679 5.47536L6.39875 5.73229L6.26575 5.55596",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92411 5.47524L6.27215 5.73217L6.40515 5.55584",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92452 5.4752L6.35711 5.47191L6.36106 5.69274",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58855 5.95822L6.45799 5.54579L6.24675 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58821 5.95817L6.23631 5.70655L6.36291 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08073 5.95817L6.43263 5.70655L6.30603 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0804 5.95822L6.21095 5.54579L6.4222 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06258 5.17676L7.92578 5.58716L8.13458 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06242 5.17676L8.19922 5.58716L7.99042 5.65916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47391 5.47532L8.04133 5.47204L8.03737 5.69287",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47433 5.47536L8.12629 5.73229L7.99329 5.55596",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65165 5.47524L7.99969 5.73217L8.13269 5.55584",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65206 5.4752L8.08465 5.47191L8.0886 5.69274",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31608 5.95822L8.18553 5.54579L7.97429 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31575 5.95817L7.96385 5.70655L8.09045 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80827 5.95817L8.16017 5.70655L8.03357 5.52557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80794 5.95822L7.93849 5.54579L8.14974 5.61027",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06258 3.44873L7.92578 3.85913L8.13458 3.93113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06242 3.44873L8.19922 3.85913L7.99042 3.93113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47391 3.74729L8.04133 3.74401L8.03737 3.96484",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47433 3.74734L8.12629 4.00426L7.99329 3.82793",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65165 3.74721L7.99969 4.00414L8.13269 3.82781",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65206 3.74717L8.08465 3.74389L8.0886 3.96472",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31608 4.23019L8.18553 3.81776L7.97429 3.88224",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31575 4.23014L7.96385 3.97853L8.09045 3.79755",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80827 4.23014L8.16017 3.97853L8.03357 3.79755",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80794 4.23019L7.93849 3.81776L8.14974 3.88224",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 24,
    height: 18,
    rx: 4,
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_1186"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 24,
    height: 18,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzbek);
export default __webpack_public_path__ + "static/media/ozbek.f77a4cc5c170014176f4f928e5b86592.svg";
export { ForwardRef as ReactComponent };